export const EVALUATED_THRESHOLD = 15;
/**
 * This number is calculated based on total passed number / total evaluated number
 */
export const COMMON_PASSED_RATE = 0.18;
